// extracted by mini-css-extract-plugin
module.exports = {"generalInformation":"GeneralInformation_generalInformation__MnNFO","h4":"GeneralInformation_h4__1PRuM","infoItem":"GeneralInformation_infoItem__1ROvM"};